"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableTitle = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_intl_1 = require("react-intl");
var TitleWrapper_1 = require("./TitleWrapper");
var constants_1 = require("../../constants");
var model_1 = require("../../../model");
var placeholderMessage = react_intl_1.defineMessage({ id: "untitled" });
/**
 * @alpha
 */
exports.EditableTitle = function (props) {
    var title = props.title, onTitleChanged = props.onTitleChanged;
    var intl = react_intl_1.useIntl();
    var dashboardTitle = model_1.useDashboardSelector(model_1.selectDashboardTitle);
    return (react_1.default.createElement(TitleWrapper_1.TitleWrapper, null,
        react_1.default.createElement(sdk_ui_kit_1.EditableLabel, { value: title, onSubmit: onTitleChanged, maxRows: 1, maxLength: constants_1.DASHBOARD_TITLE_MAX_LENGTH, className: "s-gd-dashboard-title s-dash-title dash-title editable", isEditableLabelWidthBasedOnText: true, autofocus: !dashboardTitle, placeholder: intl.formatMessage(placeholderMessage) }, title)));
};
//# sourceMappingURL=EditableTitle.js.map